import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class FullTextResponseResource {
    @JsonProperty("value")
    value: string;

    @JsonProperty("removeQuery")
    removeQuery: string;
}
